export default "__VITE_ASSET__7fea4df7__"